import React from 'react';
import { connect } from 'react-redux';
import styles from './Cognition.module.css';
import { DBCheckBox } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

class PatientCareCenterNoteWpSubjectiveCognition extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_cognition' name='Cognition' level={5}>
                <div className={styles.row}>
                    <label className={styles.col1} >Patient appears oriented to:</label>
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGPERSON' className={styles.col2} label='Person' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGPLACE' className={styles.col3} label='Place' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBCOGTIME' className={styles.col4} label='Time' />
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    return {
        noteId: noteId,
        evno: evno
    };
}

const connectedPatientCareCenterNoteWpSubjectiveCognition = connect(mapStateToProps)(PatientCareCenterNoteWpSubjectiveCognition);
export { connectedPatientCareCenterNoteWpSubjectiveCognition as PatientCareCenterNoteWpSubjectiveCognition };

